<script>
  import { BTabs } from 'bootstrap-vue'
  
  export default {
    name: 'UiTabs',
    components: {
      BTabs,
    },
  }
</script>

<template>
  <BTabs v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </BTabs>
</template>

<style lang="scss">
  .nav-tabs {

    .nav-link, .nav-link.active {
      color: var(--colors-gray-500);
      border: 0;
      border-bottom: 3px solid transparent;
      background-color: transparent;
      font-size: var(--text-lg);
      font-weight: 500;
      border-radius: 0;
    }
    .nav-link:focus-visible {
      box-shadow: var(--button-focus-shadow);
      border-radius: var(--radius-1px);
    }
    .nav-link.active {
      color: inherit;
      border-color: var(--colors-brand);
    }
  }
</style>